import React from 'react';
import { isNaN } from 'lodash';
import PropTypes from 'prop-types';
import { InputNumber } from '@sm360/widget-commons-forms';
import { PurchaseMethods, ModelYear } from '@sm360/widget-commons-vehicle';
import { LocaleService } from '@sm360/widget-commons-core-services';

import CustomizePaymentFrequency from 'payment-calculator/components/PaymentCalculatorDetails/components/CustomizePayment/CustomizePaymentFrequency.jsx';

import 'rc-slider/assets/index.css';

class CustomizePaymentTarget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            targetValue: props.purchaseMethods
                ? props.purchaseMethods.getSelectedFinanceCalculatedPayments().calculatedPaymentBeforeTaxes
                : 0,
        };

        this.setTargetPayment = this.setTargetPayment.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            targetValue: newProps.purchaseMethods
                ? newProps.purchaseMethods.getSelectedFinanceCalculatedPayments().calculatedPaymentBeforeTaxes
                : 0,
        });
    }

    setTargetPayment(value) {
        let newValue = parseFloat(value);
        if (isNaN(newValue) || newValue < 0) {
            newValue = 0;
        }
        this.setState({ targetValue: newValue });
        this.props.onTargetPaymentSlide(newValue, this.props.config);
    }

    render() {
        const calculatedPayments = this.props.purchaseMethods
            ? this.props.purchaseMethods.getSelectedFinanceCalculatedPayments()
            : null;
        let step = 25;
        if (calculatedPayments && calculatedPayments.maximumPayment < 75) {
            step = 5;
        } else if (calculatedPayments && calculatedPayments.maximumPayment < 150) {
            step = 10;
        } else if (calculatedPayments && calculatedPayments.maximumPayment < 200) {
            step = 20;
        }
        return (
            <div className="customize-payment-slider-price-wrapper">
                <div className="customize-payment--pricewrapper is-light clearfix">
                    <div className="customize-payment-title">{LocaleService.t('PAYMENT_CALCULATOR.IWANTTOPAY')} :</div>
                    <div className="customize-payment-details">
                        <InputNumber
                            min={calculatedPayments && calculatedPayments.minimumPayment}
                            max={
                                calculatedPayments &&
                                parseFloat(Math.round(calculatedPayments.maximumPayment * 100) / 100)
                            }
                            onChange={this.setTargetPayment}
                            step={step}
                            value={this.state.targetValue.toFixed(2)}
                            decimalCount={2}
                            showLabel={false}
                        />
                        <CustomizePaymentFrequency
                            purchaseMethods={this.props.purchaseMethods}
                            onPaymentFrequencyClick={this.props.onPaymentFrequencyClick}
                            modelYear={this.props.modelYear}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

CustomizePaymentTarget.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel).isRequired,
    modelYear: PropTypes.instanceOf(ModelYear.ModelYearModel).isRequired,
    onTargetPaymentSlide: PropTypes.func.isRequired,
    onPaymentFrequencyClick: PropTypes.func.isRequired,
};

CustomizePaymentTarget.displayName = 'CustomizePaymentTarget';

export default CustomizePaymentTarget;
